import { useEffect } from 'react';
import './AdSidebar.css';

interface AdSidebarProps {
  side: 'left' | 'right';
}

declare global {
  interface Window {
    adsbygoogle: unknown[];
  }
}

const AD_SLOTS = {
  left: '2832467496',
  right: '7534129838',
};

// TODO: re-enable once AdSense site verification is complete
const ADS_ENABLED = false;

export function AdSidebar({ side }: AdSidebarProps) {
  useEffect(() => {
    if (!ADS_ENABLED) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {
      // AdSense not loaded yet
    }
  }, []);

  if (!ADS_ENABLED) return null;

  return (
    <div className={`ad-sidebar ad-sidebar-${side}`}>
      <span className="ad-sidebar-label">Advertisement</span>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: '600px' }}
        data-ad-client="ca-pub-7448105661322597"
        data-ad-slot={AD_SLOTS[side]}
        data-ad-format="vertical"
        data-full-width-responsive="false"
      />
    </div>
  );
}
